import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';

import './index.css';

// Importation des composants de section et de page
import SimulatorPage from './pages/SimulatorPage';

import LeProjetPage from './pages/LeProjetPage';
import FonctionnalitesPage from './pages/FonctionnalitesPage';
import FamillePage from './pages/FamillePage';
import ViePriveePage from './pages/ViePriveePage';
import CommunautePage from './pages/CommunautePage';
import RejoindrePage from './pages/RejoindrePage';

import PolitiqueConfidentialite, { PolitiqueConfidentialiteEnfant } from './pages/PolitiqueConfidentialite';
import ContactPage from './pages/ContactPage';
import SessionDisplay from './components/SessionDisplay';
import RendezVousInvitePage from './pages/RendezVousInvitePage';
import PoliceReplayPage from './pages/PoliceReplayPage';
import PoliceRendezVousPage from './pages/PoliceRendezVousPage';
import RendezVousBackupPage from './pages/RendezVousBackupPage';
import OutingInvitePage from './pages/OutingInvitePage';
import FriendInvitePage from './pages/FriendInvitePage';

// Fait défiler la page jusqu'à l'ancre présente dans l'URL (ex: /#beta)
// après un changement de route, ce que React Router ne fait pas nativement.
const ScrollToHash = () => {
  const location = useLocation();

  useEffect(() => {
    // Ancre simple uniquement (#beta) : un fragment « k=… » est une clé de
    // lecture, ni un sélecteur ni un identifiant d'élément.
    if (/^#[A-Za-z][\w-]*$/.test(location.hash)) {
      const el = document.getElementById(location.hash.slice(1));
      if (el) {
        el.scrollIntoView({ behavior: 'smooth' });
        return;
      }
    }
    window.scrollTo({ top: 0 });
  }, [location.pathname, location.hash]);

  return null;
};

function App() {
  return (
    <Router>
      <div className="App">
        <ScrollToHash />
        <Routes>
          {/* La page d'accueil EST la page Le Projet (un seul onglet pour les deux) */}
          <Route path="/" element={<Navigate to="/le-projet" replace />} />
          <Route path="/le-projet" element={<LeProjetPage />} />
          <Route path="/fonctionnalites" element={<FonctionnalitesPage />} />
          <Route path="/famille" element={<FamillePage />} />
          <Route path="/vie-privee" element={<ViePriveePage />} />
          <Route path="/communaute" element={<CommunautePage />} />
          <Route path="/rejoindre" element={<RejoindrePage />} />
          <Route path="/rdv/:token" element={<RendezVousInvitePage />} />

          {/* Route pour le Simulateur Urbain Interactif */}
          <Route path="/simulateur" element={<SimulatorPage />} />

          {/* Routes pour les pages annexes */}
          <Route path="/politique-confidentialite/:version?" element={<PolitiqueConfidentialite />} />
          <Route path="/politique-confidentialite-enfant" element={<PolitiqueConfidentialiteEnfant />} />
          <Route path="/contact" element={<ContactPage />} />

          {/* Route pour les sessions de suivi live */}
          <Route path="/session/:sessionId" element={<SessionDisplay />} />
          <Route path="/relecture/:sessionId" element={<PoliceReplayPage />} />
          <Route path="/relecture-rdv/:rdvId" element={<PoliceRendezVousPage />} />
          <Route path="/rdv-secours/:rdvId" element={<RendezVousBackupPage />} />
          <Route path="/ami" element={<FriendInvitePage />} />
          <Route path="/rando/:code" element={<OutingInvitePage />} />
          <Route path="/sortie/:code" element={<OutingInvitePage planned />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
